export const MoreInfo = () => {
    return (
        <div className="DFWCOREBASIC" id="extraInfo">
            <h1></h1>
        </div>
    )
}